<h2>Detalhes do cliente</h2>
<form #formDetalheCliente="ngForm" id="formDetalheCliente">
  <div class="row">
    <div class="form-group">
      <span class="icon user"></span>
      <div class="inputs">
        <label for="user-name">Nome</label>
        <input
          type="text"
          class="form-control"
          maxlength="60"
          id="user-name"
          name="nomeCliente"
          placeholder="Nome do cliente"
          [(ngModel)]="fichaCadastro._client.nome"
          [charOnly]="true"
          [readonly]="fichaCadastro._client.nome && !isOutraPessoaCliente"
          appShowErrorMessages
          uppercase
          required
          requiredMessage="Nome do Cliente é obrigatório"
          appMinTwoWords
          [removeSpaceBeginEnd]="true"
        />

        <div class="detalhe-cliente__switch marginT10 check-mod">
          <app-switch
            [hidden]="fichaCadastro._client.nome === ''"
            id="user-another-name"
            name="clienteOutraPessoaCliente"
            (change)="onClickOutraPessoaCliente()"
          >
          </app-switch>
          <label *ngIf="!!fichaCadastro._client.nome">
            <span class="radio-label">Ops... Essa é outra pessoa!</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon email"></span>
      <div class="inputs">
        <label for="user-email">Email</label>
        <input
          type="text"
          maxlength="100"
          class="form-control"
          id="user-email"
          name="email"
          placeholder="email@exemplo.com.br"
          [(ngModel)]="fichaCadastro._client.email"
          appEmailValidator
          appShowErrorMessages
          lowercase
          required
          requiredMessage="Email do Cliente é obrigatório"
          (focus)="clearErrorMessage('errorMessageEmail')"
          genericErrorMessage
          [ngModelOptions]="{ updateOn: 'blur' }"
        />
        <div class="text-danger" *ngIf="isEmailAvalista">
          O E-mail informado não pode ser igual ao de outro Avalista
        </div>
        <div *ngIf="errorMessageEmail" class="text-danger">
          {{ errorMessageEmail }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon married"></span>
      <div class="inputs">
        <label for="user-married">Estado Civil</label>
        <select
          *ngIf="!isLoadingEstadosCivis"
          class="form-control"
          id="user-married"
          name="estadoCivilCliente"
          [(ngModel)]="fichaCadastro._client.idEstadoCivil"
          appShowErrorMessages
          required
          requiredMessage="Estado Civil do Cliente é obrigatório"
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option
            *ngFor="let estadoCivil of listaEstadosCivis"
            value="{{ estadoCivil.id }}"
          >
            {{ estadoCivil.descricao }}
          </option>
        </select>
        <span *ngIf="isLoadingEstadosCivis">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Carregando...
        </span>
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon id-number"></span>
      <div class="inputs">
        <label for="user-id">Documento de Identificação</label>
        <select
          class="form-control"
          id="user-id"
          name="tipoDocumentoCliente"
          [(ngModel)]="fichaCadastro._client.idTipoDocumento"
          placeholder="Digite..."
          appShowErrorMessages
          required
          requiredMessage="Tipo de Documento do Cliente é obrigatório"
        >
          <option value="undefined" selected hidden>
            Selecione o tipo de documento...
          </option>
          <option value="2">Carteira de Classe</option>
          <option value="4">Carteira de Habilitação</option>
          <option value="3">Carteira Profissional</option>
          <option value="1">Registro Geral - RG</option>
        </select>
      </div>
    </div>

    <!-- DADOS DOCUMENTOS -->
    <div class="form-group pb0">
      <span class="icon"></span>
      <div class="inputs">
        <label for="user-id">Número</label>
        <input
          type="text"
          maxlength="20"
          class="form-control"
          name="numeroDocumentoCliente"
          [(ngModel)]="fichaCadastro._client.rgIe"
          placeholder="Digite..."
          appOnlyNumberRestrictive
          appShowErrorMessages
          required
          requiredMessage="Numero do Documento do Cliente é obrigatório"
          uppercase
        />
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon"></span>
      <div class="inputs">
        <label for="user-id">Órgão Expedidor</label>
        <input
          type="text"
          maxlength="20"
          class="form-control"
          name="orgaoDocumentoCliente"
          [(ngModel)]="fichaCadastro._client.rgIeEmissor"
          placeholder="Digite..."
          appShowErrorMessages
          [charOnly]="true"
          required
          uppercase
        />
      </div>
    </div>

    <div class="form-group">
      <span class="icon"></span>
      <div class="inputs">
        <label for="emiss-doc">Data de Emissão</label>
        <input
          type="text"
          class="form-control"
          id="emiss-doc"
          name="emissaoDocumentoCliente"
          [(ngModel)]="fichaCadastro._client.rgIeData"
          placeholder="Digite apenas números"
          mask-number
          [mask]="'00/00/0000'"
          appDataEmissaoValidator
          [dataNascimento]="getDataNascimentoCliente()"
          appShowErrorMessages
          required
        />
      </div>
    </div>

    <div class="form-group">
      <span class="icon mother"></span>
      <div class="inputs">
        <label for="nomeMaeClienteSel">Nome da Mãe</label>
        <select
          *ngIf="isNomeMaeCliente && !isLoadingNomeMaeCliente"
          id="nomeMaeClienteSel"
          class="form-control"
          name="nomeMaeClienteSel"
          [(ngModel)]="fichaCadastro._client.nomeMae"
          #nomeMaeClienteSelect="ngModel"
          [required]="isNomeMaeCliente"
          appShowErrorMessages
          requiredMessage="Nome da Mãe é obrigatório"
        >
          <option value="" hidden selected>
            Escolha o nome correto da mãe do cliente
          </option>
          <option
            *ngFor="let nmc of listaNomeMaeCliente"
            value="{{ nmc.nomeMae }}"
          >
            {{ nmc.nomeMae }}
          </option>
        </select>

        <div class="text-danger" *ngIf="!isSelectedNomeMaeClienteAfterBlur">
          Nome da Mãe do Cliente é obrigatório
        </div>

        <span *ngIf="isNomeMaeCliente && isLoadingNomeMaeCliente">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Carregando...
        </span>

        <div *ngIf="!isNomeMaeCliente">
          <input
            type="text"
            maxlength="60"
            class="form-control"
            id="user-mon-other-name"
            placeholder="Digite o nome completo"
            uppercase
            [charOnly]="true"
            maxlength="60"
            uppercase
            name="nomeMaeClienteText"
            [(ngModel)]="fichaCadastro._client.nomeMae"
            #nomeMaeClienteInput="ngModel"
            appShowErrorMessages
            requiredMessage="Nome da Mãe é obrigatório"
            [required]="!isNomeMaeCliente"
            appMinTwoWords
          />
        </div>

        <div
          class="detalhe-cliente__switch marginT10 check-mod"
          *ngIf="isLoadedListaNomeMaeCliente"
        >
          <app-switch
            id="user-mother-name"
            name="clienteNomeMaeCliente"
            (change)="onClickNomeMaeCliente()"
          >
          </app-switch>
          <label>
            <span class="radio-label">Nome não encontrado na lista</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon father"></span>
      <div class="inputs">
        <label for="user-father-name">Nome do Pai</label>
        <input
          maxlength="60"
          [readonly]="isNomePaiClienteTexto"
          type="text"
          class="form-control"
          id="user-father-name"
          placeholder="Digite o nome completo"
          uppercase
          [charOnly]="true"
          maxlength="60"
          name="nomePaiCliente"
          [(ngModel)]="fichaCadastro._client.nomePai"
          appShowErrorMessages
          requiredMessage="Nome do Pai do Cliente é obrigatório"
          [required]="isNomePaiCliente"
          appMinTwoWords
        />

        <div class="detalhe-cliente__switch marginT10 check-mod">
          <app-switch
            id="user-father-name"
            name="ufn"
            (change)="onClickNomePaiCliente()"
            [(ngModel)]="isSemPaiNoRegistro"
          >
          </app-switch>
          <label>
            <span class="radio-label">Sem pai no registro</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon citizenship"></span>
      <div class="inputs">
        <label for="user-citizenship">Nacionalidade</label>
        <select
          *ngIf="!isLoadingNacionalidadeCliente"
          id="user-citizenship"
          class="form-control"
          name="nacionalidadeCliente"
          [(ngModel)]="fichaCadastro._client.idNacionalidade"
          (change)="getIdNacionalidade($event.target.value)"
          required
          autocomplete="off"
          [attr.autocomplete]="false"
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option
            *ngFor="let nc of listaNacionalidadeCliente"
            value="{{ nc.id }}"
          >
            {{ nc.descricao }}
          </option>
        </select>
        <span *ngIf="isLoadingNacionalidadeCliente">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Carregando...</span
        >
      </div>
    </div>

    <div
      class="form-group pb0"
      *ngIf="fichaCadastro._client.idNacionalidade === 1"
    >
      <span class="icon"></span>
      <div class="inputs">
        <label for="uf-nat-cli">Estado</label>
        <select
          id="uf-nat-cli"
          class="form-control"
          name="naturalUfCliente"
          (change)="onChangeNaturalUfCliente($event)"
          [disabled]="fichaCadastro._client.idNacionalidade !== 1"
          [(ngModel)]="fichaCadastro._client.naturalDeUf"
          required
          autocomplete="off"
          [attr.autocomplete]="false"
          appShowErrorMessages
          requiredMessage="Estado de Origem do Cliente é obrigatório"
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option value="AC">AC - Acre</option>
          <option value="AL">AL - Alagoas</option>
          <option value="AP">AP - Amapá</option>
          <option value="AM">AM - Amazonas</option>
          <option value="BA">BA - Bahia</option>
          <option value="CE">CE - Ceará</option>
          <option value="DF">DF - Distrito Federal</option>
          <option value="ES">ES - Espírito Santo</option>
          <option value="GO">GO - Goiás</option>
          <option value="MA">MA - Maranhão</option>
          <option value="MT">MT - Mato Grosso</option>
          <option value="MS">MS - Mato Grosso do Sul</option>
          <option value="MG">MG - Minas Gerais</option>
          <option value="PA">PA - Pará</option>
          <option value="PB">PB - Paraíba</option>
          <option value="PR">PR - Paraná</option>
          <option value="PE">PE - Pernambuco</option>
          <option value="PI">PI - Piauí</option>
          <option value="RJ">RJ - Rio de Janeiro</option>
          <option value="RN">RN - Rio Grande do Norte</option>
          <option value="RS">RS - Rio Grande do Sul</option>
          <option value="RO">RO - Rondônia</option>
          <option value="RR">RR - Roraima</option>
          <option value="SC">SC - Santa Catarina</option>
          <option value="SP">SP - São Paulo</option>
          <option value="SE">SE - Sergipe</option>
          <option value="TO">TO - Tocantins</option>
        </select>
      </div>
    </div>

    <div class="form-group" *ngIf="fichaCadastro._client.idNacionalidade === 1">
      <span class="icon"></span>
      <div class="inputs">
        <label for="user-city-cli">Cidade</label>
        <select
          *ngIf="!isLoadingNaturalCidadeCliente"
          autocomplete="off"
          [attr.autocomplete]="false"
          id="user-city-cli"
          class="form-control"
          [disabled]="
            fichaCadastro._client.idNacionalidade !== 1 ||
            !fichaCadastro._client.naturalDeUf
          "
          name="naturalCidadeCliente"
          [(ngModel)]="fichaCadastro._client.naturalDe"
          required
          appShowErrorMessages
          requiredMessage="Cidade de Origem do Cliente é obrigatório"
        >
          <option value="undefined" selected hidden>Selecione...</option>
          <option
            *ngFor="let ncid of listaNaturalCidadeCliente"
            value="{{ ncid.nomeCidade }}"
          >
            {{ ncid.nomeCidade }}
          </option>
        </select>

        <span *ngIf="isLoadingNaturalCidadeCliente">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
          Carregando...
        </span>
      </div>
    </div>

    <app-dados-profissionais
      #dadosProfissionaisComponent
      name="dadosProfissionais"
      [(ngModel)]="fichaCadastro._client.dadoProfissional"
      [isPesados]="isPesados"
      ngDefaultControl
    >
    </app-dados-profissionais>

    <div
      class="form-group"
      [ngClass]="{ 'detalhe-cliente__hidden': !isPesados }"
    >
      <span class="icon pesado"></span>
      <div class="inputs">
        <label for="user-expose">Será condutor do caminhão?</label>

        <div class="detalhe-cliente__switch marginT10 check-mod">
          <app-switch
            #condutorCaminhao
            id="condutorCaminhao"
            (change)="setCondutorCaminhao($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Sim</span>
          </label>

          <app-switch
            class="detalhe-cliente__switch_button"
            #naoCondutorCaminhao
            id="naoCondutorCaminhao"
            (change)="setCondutorCaminhao($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Não</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="isPesados">
      <span class="icon"></span>

      <div class="inputs field-group__pesados">
        <label for="tipo-transporte">Tipo de Transporte</label>

        <select
          [disabled]="isLoadingTipoTransporte"
          id="experience-time"
          class="form-control"
          name="tipoTransporte"
          required
          appShowErrorMessages
          requiredMessage="Tipo de Transporte é obrigatório"
          [(ngModel)]="fichaCadastro._client.tipoTransporte"
          (change)="onChangeTipoTransporte()"
          #tipoTransporteSelect="ngModel"
        >
          <option [value]="null || undefined" hidden selected>
            Selecione...
          </option>
          <option
            *ngFor="let tpTransporte of listaTipoTransporte"
            [ngValue]="tpTransporte.id"
          >
            {{ tpTransporte.descricao }}
          </option>
        </select>
        <div
          class="text-danger"
          *ngIf="!tipoTransporteValid && tipoTransporteTouched"
        >
          Tipo de Transporte é obrigatório
        </div>

        <input
          id="tipoTransporteOutro"
          *ngIf="showOutroTipoTransporte || showOutroTipoTransporteRecoverData"
          type="text"
          autocomplete="off"
          class="form-control field-group__outro-transporte"
          name="tipoTransporteOutro"
          [(ngModel)]="fichaCadastro._client.tipoTransporteOutro"
          placeholder="Digite outro tipo de transporte..."
          minlength="1"
          maxlength="30"
          [required]="
            showOutroTipoTransporte || showOutroTipoTransporteRecoverData
          "
          (blur)="onBlurOutroTipoTransporte()"
          uppercase
        />
        <div
          class="text-danger"
          *ngIf="
            (showOutroTipoTransporte || showOutroTipoTransporteRecoverData) &&
            (fichaCadastro._client.tipoTransporteOutro === '' ||
              fichaCadastro._client.tipoTransporteOutro === null) &&
            outroTipoTransporteTouched
          "
        >
          Campo Obrigatório
        </div>
      </div>
    </div>

    <div
      class="form-group"
      [ngClass]="{ 'detalhe-cliente__hidden': !isPesados }"
    >
      <span class="icon empresa"></span>
      <div class="inputs">
        <label for="user-expose">Presta serviço para outra empresa?</label>

        <div class="detalhe-cliente__switch marginT10 check-mod">
          <app-switch
            #prestaServicoOutraEmpresa
            id="prestaServicoOutraEmpresa"
            (change)="setPrestaServicoOutraEmpresa($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Sim</span>
          </label>

          <app-switch
            class="detalhe-cliente__switch_button"
            #naoPrestaServicoOutraEmpresa
            id="naoPrestaServicoOutraEmpresa"
            (change)="setPrestaServicoOutraEmpresa($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Não</span>
          </label>
        </div>
      </div>
    </div>

    <div
      class="detalhe-cliente__panel blue-box"
      *ngIf="
        isPesados &&
        this.fichaCadastro._client?.prestaServicoOutraEmpresa === 'S'
      "
    >
      <div class="form-group">
        <span class="icon company"></span>
        <div class="inputs">
          <label for="user-work-company">Empresa que presta serviço</label>
          <input
            type="text"
            class="form-control"
            id="user-work-company"
            placeholder="Digite o nome da empresa..."
            appShowErrorMessages
            uppercase
            [appNomeEmpresa]="true"
            requiredMessage="Nome da empresa é obrigatório"
            maxlength="40"
            minlength="3"
            name="nomeOutraEmpresa"
            [(ngModel)]="fichaCadastro._client.empresaPrestacaoServico.nome"
            required
          />
        </div>
      </div>

      <div
        class="form-group"
        [ngClass]="{ 'detalhe-cliente__hidden': !isPesados }"
      >
        <span class="icon"></span>

        <div class="inputs field-group__pesados">
          <label for="tipo-transporte">Tipo de Transporte</label>

          <select
            [disabled]="isLoadingTipoTransporte"
            id="experience-time"
            class="form-control"
            name="tipoTransporteOutraEmpresa"
            required
            appShowErrorMessages
            requiredMessage="Tipo de Transporte é obrigatório"
            [(ngModel)]="
              fichaCadastro._client.empresaPrestacaoServico.tipoTransporte
            "
            (change)="onChangeTipoTransporteOutraEmpresa()"
          >
            <option [value]="null || undefined" hidden selected>
              Selecione...
            </option>
            <option
              *ngFor="let tpTransporteOutraEmpresa of listaTipoTransporte"
              [ngValue]="tpTransporteOutraEmpresa.id"
            >
              {{ tpTransporteOutraEmpresa.descricao }}
            </option>
          </select>
          <div
            class="text-danger"
            *ngIf="
              !tipoTransporteOutraEmpresaValid &&
              tipoTransporteOutraEmpresaTouched
            "
          >
            Tipo de Transporte é obrigatório
          </div>

          <input
            id="outroTipoTransporteOutraEmpresa"
            *ngIf="
              showOutroTipoTransporteOutraEmpresa ||
              showOutroTipoTransporteOutraEmpresaRecoverData
            "
            type="text"
            autocomplete="off"
            class="form-control field-group__outro-transporte"
            name="outroTipoTransporteOutraEmpresa"
            [(ngModel)]="
              fichaCadastro._client.empresaPrestacaoServico.tipoTransporteOutro
            "
            placeholder="Digite outro tipo de transporte..."
            minlength="1"
            maxlength="30"
            [required]="
              showOutroTipoTransporteOutraEmpresa ||
              showOutroTipoTransporteOutraEmpresaRecoverData
            "
            (blur)="onBlurOutroTipoTransporteOutraEmpresa()"
            uppercase
          />
          <div
            class="text-danger"
            *ngIf="
              (showOutroTipoTransporteOutraEmpresa ||
                showOutroTipoTransporteOutraEmpresaRecoverData) &&
              (fichaCadastro._client.empresaPrestacaoServico
                .tipoTransporteOutro === '' ||
                fichaCadastro._client.empresaPrestacaoServico
                  .tipoTransporteOutro === null) &&
              outroTipoTransporteOutraEmpresaTouched
            "
          >
            Campo Obrigatório
          </div>
        </div>
      </div>

      <div
        class="form-group"
        [ngClass]="{ 'detalhe-cliente__hidden': !isPesados }"
      >
        <span class="icon company-phone"></span>
        <div class="inputs">
          <label for="user-work-company-phone"
            >Celular da empresa que presta serviço</label
          >
          <input
            type="text"
            class="form-control"
            placeholder="(00) 00000-0000"
            [minLength]="11"
            name="telefoneOutraEmpresa"
            [(ngModel)]="fichaCadastro._client.empresaPrestacaoServico.telefone"
            appShowErrorMessages
            invalidMessage="Telefone inválido"
            appTelefone
            appOnlyDigitsLengthValidator
            required
            genericErrorMessage
            (focus)="clearErrorMessage('errorMessage')"
            [ngModelOptions]="{ updateOn: 'blur' }"
            appCelularValidator
          />
          <div *ngIf="errorMessage" class="text-danger">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon patrimony"></span>
      <div class="inputs">
        <label for="user-patrimony">Valor total do Patrimônio</label>
        <input
          type="text"
          class="form-control"
          id="user-patrimony"
          placeholder="Digite apenas números"
          mask-money
          appOnlyMoney
          [prefix]="'R$'"
          [maxLength]="15"
          appOnlyDigitsLengthValidator
          appShowErrorMessages
          appMoedaValidator
          [valorMinimo]="0.01"
          required
          requiredMessage="Valor do patrimônio é obrigatório"
          name="valorPatrimonioCliente"
          [(ngModel)]="fichaCadastro._client.valorPatrimonio"
          (ngModelChange)="fichaCadastro._client.valorPatrimonio = $event"
        />
        <small>
          EX: veículo, imóvel, investimentos...<br /><strong> Importante</strong
          >: essa é uma informação exigida pelo Banco Central.
        </small>
      </div>
    </div>

    <div class="form-group">
      <span class="icon public-person"></span>
      <div class="inputs">
        <label for="user-expose">Politicamente Exposto?</label>
        <small class="subtitle">
          Exerceu cargo político nos últimos 5 anos ou é parente de algum?
        </small>

        <div class="detalhe-cliente__switch marginT10 check-mod">
          <app-switch
            #clientePpe
            id="clientePpe"
            (change)="setClientePpe($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Sim</span>
          </label>

          <app-switch
            class="detalhe-cliente__switch_button"
            #clienteNaoPpe
            id="clienteNaoPpe"
            (change)="setClientePpe($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Não</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <span class="icon public-person"></span>
      <div class="inputs">
        <label for="user-expose">FATCA</label>
        <small class="subtitle">
          Você possui obrigação fiscal com os Estados Unidos da América ou seus
          territórios?
        </small>

        <div class="detalhe-cliente__switch marginT10 check-mod">
          <app-switch
            #clienteFatca
            id="clienteFatca"
            (change)="setFatca($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Sim</span>
          </label>

          <app-switch
            class="detalhe-cliente__switch_button"
            #clienteNaoFatca
            id="clienteNaoFatca"
            (change)="setFatca($event)"
          >
          </app-switch>
          <label>
            <span class="radio-label">Não</span>
          </label>
        </div>
      </div>
    </div>

    <app-dados-referencia
      #clienteReferenciaComponent
      [fichaCadastro]="fichaCadastro._client"
      [referencia]="
        fichaCadastro._client.clienteReferencias
          ? fichaCadastro._client.clienteReferencias[0]
          : undefined
      "
      (dadosReferenciaFormEmit)="onChangeReferencia($event)"
      (dadosReferenciaFormValidEmit)="referenciaFormValid = $event"
    >
    </app-dados-referencia>

    <div class="form-group detalhe-cliente__switch check-mod">
      <span class="icon"></span>
      <app-switch #segundaReferencia (change)="onClickSegundaReferencia()">
      </app-switch>
      <label>
        <span class="radio-label">Adicionar 2ª Referência</span>
      </label>
    </div>

    <app-dados-referencia
      #clienteSegundaReferenciaComponent
      [hidden]="!isSelectedSegundaReferencia"
      [fichaCadastro]="fichaCadastro._client"
      [indexReferencia]="2"
      [referencia]="
        fichaCadastro._client.clienteReferencias
          ? fichaCadastro._client.clienteReferencias[1]
          : undefined
      "
      (dadosReferenciaFormEmit)="onChangeSegundaReferencia($event)"
      (dadosReferenciaFormValidEmit)="segundaReferenciaFormValid = $event"
    >
    </app-dados-referencia>
  </div>
</form>

<div class="row">
  <div class="marginT30 form-group tab-buttons">
    <a
      (click)="onClickPrevious()"
      class="bt-back btn btn-border-orange pull-left"
      *ngIf="!fichaCadastro.getFichaLocalStorage"
    >
      <i class="fa fa-arrow-left mrBt"></i>
      Voltar
    </a>
    <a
      class="bt-go btn btn-full-orange pull-right"
      [ngClass]="{
        disabled:
          !this.formDetalheClienteValid(formDetalheCliente) ||
          !detalhesClienteValid
      }"
      (click)="onClickNext()"
    >
      Continuar
      <i class="fa fa-arrow-right mlBt"></i>
    </a>
  </div>
</div>
